import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransition"] */ "/vercel/path0/frontend/src/components/layout/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceHero"] */ "/vercel/path0/frontend/src/components/services/ServiceHero.tsx");
